export const scenariosBank = {
  employee: [
    {
      id: "salary-delay",
      question:
        "Your employer has not paid your salary for two months. What should you do first?",
      options: [
        "Ignore the problem and wait",
        "Quit your job immediately",
        "Check your contract and collect proof",
      ],
      correctIndex: 2,
      explanation:
        "You have the right to receive your salary on time. Reviewing your contract and collecting proof of unpaid wages helps you clearly show that this right was not respected.",
    },
    {
      id: "unsafe-workplace",
      question:
        "Your workplace is unsafe and may cause injury. What is the best first step?",
      options: [
        "Continue working without saying anything",
        "Report the issue and document the danger",
        "Post about it on social media",
      ],
      correctIndex: 1,
      explanation:
        "You have the right to a safe working environment. Reporting and documenting safety risks helps protect this right and shows that the danger is real.",
    },
    {
      id: "unfair-termination",
      question:
        "You were fired without explanation or warning. What should you do first?",
      options: [
        "Accept it without asking",
        "Review your contract and termination notice",
        "Confront your employer aggressively",
      ],
      correctIndex: 1,
      explanation:
        "You have the right to fair and lawful termination. Reviewing your contract helps you understand whether proper procedures were followed.",
    },
    {
      id: "overtime-pay",
      question:
        "You are regularly asked to work overtime without extra pay. What should you do first?",
      options: [
        "Work silently to avoid conflict",
        "Ask for written clarification about overtime rules",
        "Refuse all extra work immediately",
      ],
      correctIndex: 1,
      explanation:
        "You have the right to fair compensation for your work. Asking for written clarification helps confirm whether overtime pay applies to you.",
    },
    {
      id: "workplace-discrimination",
      question:
        "You feel you are treated unfairly at work because of your background. What is the best first step?",
      options: [
        "Stay silent to avoid trouble",
        "Document incidents and seek guidance",
        "Confront colleagues angrily",
      ],
      correctIndex: 1,
      explanation:
        "You have the right to equal and fair treatment at work. Documenting incidents helps show how this right may have been violated.",
    },
  ],
    student: [
    {
      id: "unfair-grades",
      question:
        "You believe your exam was graded unfairly. What should you do first?",
      options: [
        "Argue with the professor publicly",
        "Review grading criteria and request clarification",
        "Ignore it completely",
      ],
      correctIndex: 1,
      explanation:
        "You have the right to fair evaluation. Reviewing grading criteria helps you understand whether this right was respected.",
    },
    {
      id: "tuition-dispute",
      question:
        "Your university charged unexpected tuition fees. What is the best first step?",
      options: [
        "Refuse to pay without asking",
        "Check official fee policies and request explanation",
        "Post complaints online",
      ],
      correctIndex: 1,
      explanation:
        "You have the right to transparent fees. Checking official policies helps you confirm whether the charges are justified.",
    },
    {
      id: "disciplinary-action",
      question:
        "You received a disciplinary warning you believe is unfair. What should you do?",
      options: [
        "Accept it silently",
        "Review the student code and appeal procedures",
        "Threaten legal action immediately",
      ],
      correctIndex: 1,
      explanation:
        "You have the right to fair disciplinary procedures. Reviewing the student code explains how decisions can be challenged.",
    },
    {
      id: "class-attendance",
      question:
        "You were penalized for missing classes due to illness. What should you do first?",
      options: [
        "Do nothing",
        "Review attendance policy and provide documentation",
        "Publicly complain about the policy",
      ],
      correctIndex: 1,
      explanation:
        "You have the right to reasonable consideration in academic policies. Providing documentation helps show that your absence was justified.",
    },
    {
      id: "access-to-records",
      question:
        "You want to review your academic records but face delays. What is the best first step?",
      options: [
        "Give up on the request",
        "Submit a formal request through official channels",
        "Ask other students for copies",
      ],
      correctIndex: 1,
      explanation:
        "You have the right to access your academic records. Submitting a formal request helps ensure this right is respected.",
    },
  ],
};
